import Icon from '@/Components/UI/Icon/Icon';
import './menuItem.scss';
import clsx from 'clsx';

const separatorStyle = {
  height: '1px',
  borderTop: '1px solid #D6D6D6',
  display: 'block',
  cursor: 'auto',
  margin: '8px 0 8px 0',
  background: '#FBFBFB',
};

export const MenuItem = ({ item: { iconName, name, action, disabled, submenu = [] } }) => {
  const menuItemClasses = clsx('menu-option-cust bg rounded', {
    'separator-cust': name === 'separator',
    'ag-menu-option-disabled': disabled,
  });

  return (
    <div
      data-rec={name !== 'separator' ? 'customContextHeaderMenuItem' : ''}
      data-cy={`header-menu-item-${name}`}
      tabIndex={0}
      onKeyUp={() => {}}
      role='button'
      onClick={name === 'separator' ? () => null : action}
      style={name === 'separator' ? separatorStyle : {}}
      className={menuItemClasses}
    >
      <span className='menu-option-part-cust menu-option-icon-cust'>
        {name !== 'separator' && <Icon name={iconName} />}
      </span>
      <span
        data-cy={`header-menu-item-text-${name}`}
        className='menu-option-part-cust menu-option-text-cust'
      >
        {name !== 'separator' && name}
      </span>
      <span className='menu-option-part-cust menu-option-popup-pointer-cust'>
        {submenu.length > 0 && <Icon name='caret-right' />}
      </span>

      {submenu.length > 0 && (
        <div className='submenu-cust'>
          {submenu.map((subItem, index) => (
            <MenuItem key={index} item={subItem} />
          ))}
        </div>
      )}
    </div>
  );
};
